import React from "react";
import _ from "underscore";
import config from "../../../config";
import Card from "react-bootstrap/Card";
import Item from "./Item";
import {canSeeFirstLook, extractOptionFromBC, getActiveAuction, isBetweenDates} from "../../common/utils";
import TwoLevelsMenu from "./TwoLevelsMenu";
import Button from "react-bootstrap/Button";
import TwoLevelsMenuOthers from "./TwoLevelsMenuOthers";
import Points from "../../common/Points";
import Currency from "../../common/Currency";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import FirstLookNav from "../common/FirstLookNav";
import AuctionNav from "../common/AuctionNav";
import {BoxIcon, ChecklistIcon, ReferIcon, RibbonIcon, WalletIcon} from "../../common/Icons";

const buildStoreUrl = (store_name) => {
    return `${config.host_rebag_shop}/collections/all-bags?_=pf&pf_st_availability_hidden=true&pf_t_stores=bc-filter-${store_name}`;
}

class ItemsList extends React.Component {
    constructor() {
        super();

        const init = {
            eventKey: null,
        };

        this.initial_menus_state = {
            show_bags_menu: false,
            show_accessories_menu: false,
            show_watches_menu: false,
            show_jewelry_menu: false,
            show_apparel_menu: false,
            show_shoes_menu: false,
            show_designers_menu: false,
            show_magazine_menu: false,
            show_gifts_menu: false,
            show_stores_menu: false,
            show_clair_by_rebag: false,
            show_sales_menu: false
        };

        this.sidebarRef = React.createRef();
        this.twoLevelsMenuRef = React.createRef();
        this.twoLevelsMenuContentRef = React.createRef();
        this.state = {...this.initial_menus_state, init};
        this.setEventKey = this.setEventKey.bind(this);
        this.showHideMenus = this.showHideMenus.bind(this);
    }

    componentDidUpdate() {
        const {sidebarOpen} = this.props;
        const {
            show_bags_menu, show_accessories_menu, show_watches_menu, show_jewelry_menu,
            show_apparel_menu, show_shoes_menu,
            show_designers_menu, show_magazine_menu, show_gifts_menu, show_stores_menu
        } = this.state;

        if (sidebarOpen) {
            this.sidebarRef.current.focus();
        }

        if (show_bags_menu || show_accessories_menu || show_watches_menu || show_jewelry_menu || show_apparel_menu || show_shoes_menu || show_designers_menu || show_magazine_menu || show_gifts_menu || show_stores_menu) {
            this.twoLevelsMenuRef.current.focus();
        }

        if(this.twoLevelsMenuContentRef.current){
            this.twoLevelsMenuRef.current.scrollIntoView();
        }
    }

    showHideMenus(action, mobile_submenu_open_by_default) {
        this.setState({...this.initial_menus_state, ...action, eventKey: mobile_submenu_open_by_default || "1"});
        this.sidebarRef.current.scrollIntoView();
    };

    setEventKey(event_key){
        this.setState({
            eventKey: event_key
        })
    }

    renderAuthPopup(login, msg) {
        this.props.openLoginModal(login, msg);
    }

    render(){
        const {
            show_bags_menu, show_accessories_menu, show_watches_menu, show_jewelry_menu, show_apparel_menu, show_shoes_menu, show_designers_menu,
            show_magazine_menu, show_gifts_menu, show_stores_menu, eventKey, show_clair_by_rebag, show_sales_menu
        } = this.state;
        const {
            onSetSidebarOpen, user, designers, vault_articles, stores, bc_filter_tree, openLoginModal, sidebarOpen,
            openLogoutModal, user_profile, current_tier
        } = this.props;
        const vault_articles_list = vault_articles && vault_articles.items;

        const designers_popular = designers ? _.filter(designers, (designer) => {
            return designer.show_in_mobile === true;
        }) : [];

        const stores_az = (_.sortBy(stores, "name"));

        if((vault_articles_list && _.isEmpty(vault_articles_list)) || _.isEmpty(stores)){
            return null;
        }
        const can_participate_to_auction = getActiveAuction();
        const can_see_first_look_items = user_profile ? canSeeFirstLook(user_profile) : false;
        const is_b2b = user_profile ? user_profile.is_b2b : false;

        return (
            <Navbar
                as="div"
                ref={this.sidebarRef}
                className="list-group"
                tabIndex={`${sidebarOpen ? "0" : "-1"}`}
            >
                <Nav.Item
                    className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--top sidebar-menu-nav__top-item--close-container"
                >
                    <Button
                        className="sidebar-menu-nav__top-item--close"
                        onClick={() => onSetSidebarOpen(false)}
                        variant="clean"
                        aria-label="Close"
                    >
                        <span className="icon-close" />
                    </Button>
                </Nav.Item>
                {user_profile &&
                    <>
                        <Nav.Item
                            as="a"
                            className={`sidebar-menu-nav__top-item--secondary sidebar-menu-nav__top-item--${current_tier.key}`}
                            href={`${config.host_rebag}/my-account/rebag-rewards`}
                        >
                            <div className="header-top-nav__rr-details header-top-nav__rr-details--mobile">
                                {current_tier.key !== "no_tier" &&
                                <div className="header-top-nav__rr-item-container">
                                    <span className={`header-top-nav__rr-tier-icon rr-tier-icon rr-tier-icon--${current_tier.key}`}/>
                                </div>
                                }
                                <div className="header-top-nav__rr-item-container">
                                    <div className="header-top-nav__rr-text-container">
                                        <span className="header-top-nav__rr-name">{user_profile.first_name ? user_profile.first_name : user_profile.email}</span>
                                    </div>
                                    <div className="header-top-nav__rr-text-container">
                                        <Currency value={user_profile.wallet_total} className="header-top-nav__rr-text"/> <span className="header-top-nav__rr-text">Wallet Balance</span>
                                    </div>
                                </div>
                            </div>
                        </Nav.Item>
                        <div className="header-top-nav__rr-mobile-menu-profile">
                            <div className="header-top-nav__rr-mobile-menu-profile-inner">
                                <Nav.Item
                                    as="a"
                                    className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--section-title"
                                    href={`${config.host_rebag}/my-account`}
                                >
                                    My Account
                                </Nav.Item>
                                <Nav.Item
                                    as="a"
                                    href={`${config.host_rebag}/my-account/purchases`}
                                    aria-label="My Orders"
                                    className="sidebar-menu-nav__top-item--secondary"
                                >
                                    <BoxIcon
                                        style={{width: 18, marginRight: 10}}
                                        className="header-top-nav__rr-mobile-icon"
                                        label="Orders"
                                    />
                                    Orders
                                </Nav.Item>
                                <Nav.Item
                                    as="a"
                                    aria-label="My Submissions"
                                    href={`${config.host_rebag}/my-account/submissions`}
                                    className="sidebar-menu-nav__top-item--secondary"
                                >
                                    <ChecklistIcon
                                        style={{width: 14, marginLeft: 2, marginRight: 12}}
                                        className="header-top-nav__rr-mobile-icon"
                                        label="Submissions"
                                    />
                                    Submissions
                                </Nav.Item>
                                <Nav.Item
                                    as="a"
                                    aria-label="Wallet"
                                    href={`${config.host_rebag}/my-account/wallet`}
                                    className="sidebar-menu-nav__top-item--secondary"
                                >
                                    <WalletIcon
                                        style={{width: 18, marginRight: 10}}
                                        className="header-top-nav__rr-mobile-icon"
                                        label="Rebag Wallet"
                                    />
                                    Wallet
                                </Nav.Item>
                                <Nav.Item
                                    as="a"
                                    aria-label="My Account"
                                    href={`${config.host_rebag}/my-account/rebag-rewards`}
                                    className="sidebar-menu-nav__top-item--secondary"
                                >
                                    <RibbonIcon
                                        style={{width: 13, marginLeft: 3, marginRight: 12}}
                                        className="header-top-nav__rr-mobile-icon"
                                        label="Rebag Rewards Summary"
                                    />
                                    Rebag Rewards
                                </Nav.Item>
                                <Nav.Item
                                    id="friendbuyoverlay"
                                    as="a"
                                    aria-label="Refer a Friend"
                                    className="sidebar-menu-nav__top-item--secondary"
                                >
                                    <ReferIcon
                                        style={{width: 22, padding: 2, marginRight: 6}}
                                        className="header-top-nav__rr-mobile-icon"
                                        label="Refer a Friend"
                                    />
                                    Refer a Friend
                                </Nav.Item>
                            </div>
                        </div>
                    </>
                }
                <Nav.Item
                    as="a"
                    className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--top sidebar-menu-nav__top-item--section-title"
                    href={config.host_rebag}
                >
                    Home
                </Nav.Item>

                {_.map(config.header_menu_items, (header_menu_item, idx) => {
                    if (header_menu_item.show_sidebar) {
                        return (
                            <Item
                                key={idx}
                                class_name="sidebar-menu-nav__top-item"
                                menu_item={header_menu_item}
                                showHideMenus={this.showHideMenus}
                                is_b2b={is_b2b}
                            />
                        )
                    }
                })}
                {!can_participate_to_auction && can_see_first_look_items &&
                    <FirstLookNav
                        can_see_first_look_items={can_see_first_look_items}
                        className='sidebar-menu-nav__top-item'
                    />
                }
                {can_participate_to_auction &&
                    <AuctionNav
                        className='sidebar-menu-nav__top-item'
                        user_profile={user_profile}
                    />
                }
                <Nav.Item
                    as="a"
                    className="sidebar-menu-nav__top-item--cta"
                    href={`${config.host_rebag}/sell-now/`}
                >
                    Sell
                </Nav.Item>
                <Nav.Item
                    as="a"
                    className="sidebar-menu-nav__top-item list-group-item"
                    onClick={() => this.showHideMenus({show_clair_by_rebag: !show_clair_by_rebag})}
                >
                    Clair by Rebag
                    <span className={`icon-chevron-${show_clair_by_rebag ? "up" : "down"}`}/>
                </Nav.Item>
                {show_clair_by_rebag &&
                <div className="header-top-nav__rr-mobile-menu-clair">
                    <Nav.Item
                        as="a"
                        className="sidebar-menu-nav__top-item--secondary"
                        href={`${config.host_rebag}/partners/`}
                    >
                        Clair for Business
                    </Nav.Item>
                    <Nav.Item
                        as="a"
                        className="sidebar-menu-nav__top-item--secondary"
                        href={`${config.host_rebag}/trade/`}
                    >
                        Trade
                    </Nav.Item>
                    <Nav.Item
                        as="a"
                        className="sidebar-menu-nav__top-item--secondary"
                        href={`${config.host_rebag}/clair/`}
                    >
                        About Clair
                    </Nav.Item>
                    {user &&
                        <Nav.Item
                            as="a"
                            className="sidebar-menu-nav__top-item--secondary"
                            href={`${config.host_rebag}/my-account/clair-codes`}
                        >
                            Clair Codes
                        </Nav.Item>
                    }
                </div>
                }
                {!user &&
                <>
                    <Nav.Item
                        className="sidebar-menu-nav__top-item--secondary"
                        as="button"
                        onClick={() => {
                            openLoginModal('login');
                            onSetSidebarOpen(false);
                        }}
                    >
                        Login
                    </Nav.Item>
                    <Nav.Item
                        className="sidebar-menu-nav__top-item--secondary"
                        as="button"
                        onClick={() => {
                            openLoginModal('signup');
                            onSetSidebarOpen(false);
                        }}
                    >
                        Sign Up
                    </Nav.Item>
                </>
                }
                {user &&
                <>
                    <Nav.Item
                        as="a"
                        className="sidebar-menu-nav__top-item--secondary"
                        href={`${config.host_rebag}/my-account/profile`}
                    >
                        Profile
                    </Nav.Item>
                    <Nav.Item
                        className="sidebar-menu-nav__top-item--secondary"
                        as="button"
                        onClick={() => {
                            openLogoutModal();
                            onSetSidebarOpen(false);
                        }}
                    >
                        Logout
                    </Nav.Item>
                </>
                }
                <Nav.Item
                    as="a"
                    className="sidebar-menu-nav__top-item--secondary"
                    href={`${config.host_rebag}/faq/`}
                >
                    Help
                </Nav.Item>
                <Nav.Item
                    as="a"
                    className="sidebar-menu-nav__top-item--secondary"
                    href={`${config.host_rebag}/contact/`}
                >
                    Contact Us
                </Nav.Item>

                {show_bags_menu &&
                    <TwoLevelsMenu
                        menu_key={'bags'}
                        eventKey={eventKey}
                        bc_filter_tree={bc_filter_tree}
                        showHideMenus={this.showHideMenus}
                        setEventKey={this.setEventKey}
                        twoLevelsMenuRef={this.twoLevelsMenuRef}
                    />
                }
                {show_accessories_menu &&
                    <TwoLevelsMenu
                        menu_key={'accessories'}
                        eventKey={eventKey}
                        bc_filter_tree={bc_filter_tree}
                        showHideMenus={this.showHideMenus}
                        setEventKey={this.setEventKey}
                        twoLevelsMenuRef={this.twoLevelsMenuRef}
                    />
                }

                {show_watches_menu &&
                    <TwoLevelsMenuOthers
                        menu_key={'watches'}
                        eventKey={eventKey}
                        bc_filter_tree={bc_filter_tree}
                        showHideMenus={this.showHideMenus}
                        setEventKey={this.setEventKey}
                        twoLevelsMenuRef={this.twoLevelsMenuRef}
                        show_watches_menu={show_watches_menu}
                        designers={_.filter(designers, (designer) => {
                            return designer.show_in_watches === true;
                        })}
                    />
                }
                {show_jewelry_menu &&
                    <TwoLevelsMenuOthers
                        menu_key={'jewelry'}
                        eventKey={eventKey}
                        bc_filter_tree={bc_filter_tree}
                        showHideMenus={this.showHideMenus}
                        setEventKey={this.setEventKey}
                        twoLevelsMenuRef={this.twoLevelsMenuRef}
                        show_jewelry_menu={show_jewelry_menu}
                        designers={_.filter(designers, (designer) => {
                            return designer.show_in_jewelry === true;
                        })}
                    />
                }
                {show_apparel_menu &&
                    <TwoLevelsMenuOthers
                        menu_key={'apparel'}
                        eventKey={eventKey}
                        bc_filter_tree={bc_filter_tree}
                        showHideMenus={this.showHideMenus}
                        setEventKey={this.setEventKey}
                        twoLevelsMenuRef={this.twoLevelsMenuRef}
                        show_apparel_menu={show_apparel_menu}
                        designers={_.filter(designers, (designer) => {
                            return designer.show_in_apparel === true;
                        })}
                    />
                }
                {show_shoes_menu &&
                    <TwoLevelsMenuOthers
                        menu_key={'shoes'}
                        eventKey={eventKey}
                        bc_filter_tree={bc_filter_tree}
                        showHideMenus={this.showHideMenus}
                        setEventKey={this.setEventKey}
                        twoLevelsMenuRef={this.twoLevelsMenuRef}
                        show_shoes_menu={show_shoes_menu}
                        designers={_.filter(designers, (designer) => {
                            return designer.show_in_shoes === true;
                        })}
                    />
                }
                {show_designers_menu &&
                <React.Fragment>
                    <div
                        className="sidebar-menu-nav__submenu"
                        ref={this.twoLevelsMenuRef}
                        tabIndex="0"
                    >
                        <div className="sidebar-menu-nav__submenu-button-container">
                            <Nav.Item as="button" onClick={this.showHideMenus} className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--back-container">
                                <span className="icon-arrow-left sidebar-menu-nav__top-item--back"/>
                                Menu
                            </Nav.Item>
                        </div>
                        <div className="clearfix"/>
                        <Nav.Item as="span" className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--top sidebar-menu-nav__top-item--title">
                            Designers
                            <Button
                                href={`${config.host_rebag_shop}/collections`}
                                variant="clean"
                                className="sidebar-menu-nav__mobile-all-category-btn"
                            >
                                View All
                                <span className="icon-arrow-right sidebar-menu-nav__mobile-all-category-icon"/>
                            </Button>
                        </Nav.Item>
                        <div className="side-menu">
                            {_.map(designers_popular, (designer) => {
                                return (
                                    <Card.Link
                                        key={designer.id}
                                        href={`${config.host_rebag_shop}/collections/${designer.slug}?sort=created-descending&_=pf`}
                                    >
                                        {designer.name}
                                        {designer.is_new === true && <span className="top-nav__new-label">New</span>}
                                    </Card.Link>
                                );
                            })}
                        </div>
                    </div>
                </React.Fragment>
                }
                {show_magazine_menu &&
                <React.Fragment>
                    <div
                        className="sidebar-menu-nav__submenu"
                        ref={this.twoLevelsMenuRef}
                        tabIndex="0"
                    >
                        <div className="sidebar-menu-nav__submenu-button-container">
                            <Nav.Item as="button" onClick={this.showHideMenus} className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--back-container">
                                <span className="icon-arrow-left sidebar-menu-nav__top-item--back"/>
                                Menu
                            </Nav.Item>
                        </div>
                        <div className="clearfix"/>
                        <Nav.Item as="span" className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--top sidebar-menu-nav__top-item--title">The Vault</Nav.Item>
                        <div className="side-menu">
                            {_.map(vault_articles_list, (article, idx) => {
                                return (
                                    <Card.Link
                                        key={idx}
                                        href={article.url}
                                    >
                                        {article.title}
                                    </Card.Link>
                                )
                            })}
                            <Card.Link
                                className="card-link--last"
                                href={config.host_rebag_vault}
                            >
                                All Articles
                            </Card.Link>
                        </div>
                    </div>
                </React.Fragment>
                }
                {show_gifts_menu &&
                <React.Fragment>
                    <div
                        className="sidebar-menu-nav__submenu"
                        ref={this.twoLevelsMenuRef}
                        tabIndex="0"
                    >
                        <div className="sidebar-menu-nav__submenu-button-container">
                            <Nav.Item as="button" onClick={this.showHideMenus} className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--back-container">
                                <span className="icon-arrow-left sidebar-menu-nav__top-item--back"/>
                                Menu
                            </Nav.Item>
                        </div>
                        <div className="clearfix"/>
                        <Nav.Item as="span" className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--top sidebar-menu-nav__top-item--title">The Gift Suite</Nav.Item>
                        <div className="side-menu">
                            {_.map(config.gift_collections, (collection, idx) => {
                                return (
                                    <Card.Link
                                        key={idx}
                                        href={collection.url}
                                    >
                                        {collection.title}
                                    </Card.Link>
                                )
                            })}
                        </div>
                    </div>
                </React.Fragment>
                }
                {show_sales_menu &&
                <React.Fragment>
                    <div
                        className="sidebar-menu-nav__submenu"
                        ref={this.twoLevelsMenuRef}
                        tabIndex="0"
                    >
                        <div className="sidebar-menu-nav__submenu-button-container">
                            <Nav.Item as="button" onClick={this.showHideMenus} className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--back-container">
                                <span className="icon-arrow-left sidebar-menu-nav__top-item--back"/>
                                Menu
                            </Nav.Item>
                        </div>
                        <div className="clearfix"/>
                        <Nav.Item
                            as="span"
                            className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--top sidebar-menu-nav__top-item--title"
                        >
                            Sale
                        </Nav.Item>
                        <div
                            className="side-menu"
                            ref={this.twoLevelsMenuContentRef}
                        >
                            {
                                _.chain(config.header_menu_items).filter((menu_item) => { return menu_item.key === 'sales'}).pluck('collections').map((collections) => {
                                    return collections.map((collection) => {
                                        return (
                                            <Card.Link
                                                key={collection.title}
                                                href={collection.url}
                                            >
                                                {collection.title}
                                            </Card.Link>
                                        )
                                    })
                                }).value()
                            }
                        </div>
                    </div>
                </React.Fragment>
                }
                {show_stores_menu &&
                <React.Fragment>
                    <div
                        className="sidebar-menu-nav__submenu"
                        ref={this.twoLevelsMenuRef}
                        tabIndex="0"
                    >
                        <div className="sidebar-menu-nav__submenu-button-container">
                            <Nav.Item as="button" onClick={this.showHideMenus} className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--back-container">
                                <span className="icon-arrow-left sidebar-menu-nav__top-item--back"/>
                                Menu
                            </Nav.Item>
                        </div>
                        <div className="clearfix"/>
                        <Nav.Item as="span" className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--top sidebar-menu-nav__top-item--title">Stores</Nav.Item>
                        <div className="side-menu">
                            {_.map(stores_az, (store, idx) => {
                                return (
                                    <Card.Link
                                        key={idx}
                                        href={buildStoreUrl(store.name)}
                                    >
                                        {store.name}
                                    </Card.Link>
                                )
                            })}
                            <Card.Link
                                className="card-link--last"
                                href={`${config.host_rebag}/store/`}
                            >
                                All Stores
                            </Card.Link>
                        </div>
                    </div>
                </React.Fragment>
                }
            </Navbar>
        )
    }
}

export default ItemsList;